import dynamic from "next/dynamic";
import { forwardRef, useCallback, useMemo, useState } from "react";
import { Image, ResponsiveImageType } from "react-datocms/image";
import Slider, { Settings } from "react-slick";
import { ProductBySlugQuery } from "services/datocms/generated";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

const ModelViewer = dynamic(() => import("./ModelViewer"), {
  ssr: false,
});

type BigImageSliderProps = {
  items: ResponsiveImageType[];
  datoProduct: ProductBySlugQuery["product"];
  setSelectedImage: (index: number) => void;
};

export const BigImageSlider = forwardRef<Slider, BigImageSliderProps>(
  ({ items, datoProduct, setSelectedImage }, sliderRef) => {
    const [swipe, setSwipe] = useState(true);

    const beforeChange = useCallback(
      (preSlide: number, nextSlide: number) => {
        if (datoProduct?.product3dModel?.url && nextSlide === items.length) {
          setSwipe(false);
        } else {
          setSwipe(true);
        }
        setSelectedImage(nextSlide);
      },
      [datoProduct?.product3dModel?.url, items.length, setSelectedImage],
    );

    const settings: Settings = useMemo(
      () => ({
        speed: 500,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        swipe,
      }),
      [swipe],
    );

    return (
      <div className="w-full h-[362px] md:h-[424px]">
        <Slider {...settings} ref={sliderRef} beforeChange={beforeChange}>
          {items.map((item, idx) => (
            <div key={item.src}>
              <div className="flex justify-center">
                <Image
                  data={item}
                  objectFit="contain"
                  layout="responsive"
                  pictureClassName="h-[362px] md:h-[424px]"
                />
              </div>
            </div>
          ))}
          {datoProduct?.product3dModel?.url && (
            <ModelViewer
              src={datoProduct?.product3dModel?.url}
              poster={datoProduct?.product3dPoster?.responsiveImage?.src}
              alt={`${datoProduct.title} 3D`}
            />
          )}
        </Slider>
      </div>
    );
  },
);
